function getDocumentHead() {
  return document.head || {};
}

export default function createDOMNode(type, anchorNode) {
  var media = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var support = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  var head = getDocumentHead();

  var node = document.createElement('style');
  node.setAttribute('data-fela-type', type);
  node.type = 'text/css';

  if (support) {
    node.setAttribute('data-fela-support', 'true');
  }

  if (media.length > 0) {
    node.media = media;
  }

  var parentNode = anchorNode ? anchorNode.parentNode : head;

  if (support || media.length > 0) {
    parentNode.appendChild(node);
  } else if (anchorNode) {
    parentNode.insertBefore(node, anchorNode);
  } else {
    parentNode.appendChild(node);
  }

  return node;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/fela-dom/es/dom/createDOMNode.js
// module id = 855
// module chunks = 1